import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "../../../dist/assets/stylesheets/css/notification.css";

/**
 * Renders children into document.body so overlays escape scroll/overflow clipping
 * from `.parent-container` and cover the full viewport including the fixed sidebar.
 */
function GlobalOverlayPortal({ children, className = "" }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return createPortal(
    <div
      className={`app-global-overlay-root ${className}`.trim()}
      role="presentation"
      data-testid="global-overlay-portal"
    >
      {children}
    </div>,
    document.body
  );
}

export default GlobalOverlayPortal;
